import React, { memo } from "react";
import { Box } from "@chakra-ui/layout";
import { SkeletonText } from "@chakra-ui/react";
import { Table, Tbody, Td, Th, Tr, Thead } from "@chakra-ui/table";
import { CherryHubAdminApi } from "../../api/adminApiModels";
import { CopyText } from "../Utilities/CopyText";
import { PreviewButton } from "../Utilities/PreviewButton";

interface StatusTableProps {
  passStatus: CherryHubAdminApi.CherryPassStatusSummary[] | null | undefined;
  isLoading: boolean;
}

export const StatusTable = memo(
  ({ passStatus, isLoading }: StatusTableProps) => {
    return (
      <Box w="100%" overflowX="auto">
        <Table size="sm">
          <Thead>
            <Tr>
              <Th whiteSpace="nowrap">Business ID</Th>
              <Th whiteSpace="nowrap">Business Name</Th>
              <Th whiteSpace="nowrap">Invitation Type</Th>
              <Th whiteSpace="nowrap">Total Downloaded</Th>
            </Tr>
          </Thead>
          <Tbody>
            {!isLoading &&
              (passStatus ?? []).map((status, userIdx) => (
                <Tr key={userIdx}>
                  <Td
                    width="0.1%"
                    whiteSpace="nowrap"
                    title="Copy business id."
                  >
                    <CopyText hover={true}>{status.BusinessId!}</CopyText>&nbsp;
                  </Td>
                  <Td title="View business.">
                    <PreviewButton
                      url={`/admin/businesses/${status.BusinessId}`}
                      linkProps={{ target: "_self" }}
                      hover={true}
                    >
                      {status.BusinessName}
                    </PreviewButton>
                  </Td>
                  <Td>{status.InvitationType}</Td>
                  <Td width="0.1%" whiteSpace="nowrap">
                    {status.TotalDownloaded}
                  </Td>
                </Tr>
              ))}
            {isLoading && (
              <Tr>
                <Td width="20%">
                  <SkeletonText noOfLines={12} spacing="4" width="100%" />
                </Td>
                <Td width="45%">
                  <SkeletonText noOfLines={12} spacing="4" width="100%" />
                </Td>
                <Td width="20%">
                  <SkeletonText noOfLines={12} spacing="4" width="100%" />
                </Td>
                <Td width="15%" whiteSpace="nowrap">
                  <SkeletonText noOfLines={12} spacing="4" width="100%" />
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </Box>
    );
  }
);
